import { UsersIcon, LinkIcon, PencilAltIcon } from "@heroicons/react/outline";
import { useSession } from "next-auth/react";
import Link from "next/link";
import { getCompanySize } from "../../../../../common/constants";
import LocationIcon from "../../../../components/Icons/LocationIcon";

export default function Hero({
    city,
    title,
    logo,
    excerpt,
    size,
    link,
    slug,
    premium,
}) {
    const { data: session } = useSession();

    const isCompanyOwner = session?.company?.slug === slug;
    const isAdmin = session?.user?.role === "ADMIN";

    return (
        <section className="bg-gray-light">
            <div className="py-24 text-center max-w-screen-sm m-auto px-6 lg:px-0">
                <div className="relative mb-4">
                    <img
                        src={logo}
                        className="w-16 block m-auto rounded-full -mb-1"
                    />
                    {premium && (
                        <span className="-mt-2 text-xs bg-premium-300 text-white px-2 py-1 rounded-md">
                            premium
                        </span>
                    )}
                </div>
                <h1 className="md:text-4xl leading-tight pb-4 font-semibold flex justify-center">
                    {title}
                    {(isAdmin || isCompanyOwner) && (premium || isAdmin) && (
                        <Link href={`/kreiraj/kompaniju?slug=${slug}`}>
                            <a>
                                <PencilAltIcon className="w-6 ml-2" />
                            </a>
                        </Link>
                    )}
                </h1>
                <div className="flex text-sm items-center justify-center">
                    <LocationIcon />
                    <p className="mr-6 text-gray-dark">{city}</p>
                    <UsersIcon
                        className="h-4 w-4 mr-1 text-gray-dark"
                        aria-hidden="true"
                    />
                    <p className="mr-6 text-gray-dark">
                        {getCompanySize[size]}
                    </p>
                    <LinkIcon
                        className="h-4 w-4 mr-1 text-gray-dark"
                        aria-hidden="true"
                    />
                    <p className="text-gray-dark">
                        <a href={link} target="_blank">
                            Website
                        </a>
                    </p>
                </div>
                <h2 className="text-base mt-6">{excerpt}</h2>
            </div>
        </section>
    );
}
